export const BorderLine = "1px solid rgb(237, 235, 233)";
